module.exports = __webpack_public_path__ + "img/home-arguments-nodelay.f7bfe37d.svg";